import React from "react";
import { t } from "ttag";
import { BaseDialog, Typography } from "@coolremote/shared";
import { useStoreActions, useStoreState } from "../../../models/RootStore";
import useStyles from "./DeviceBlockedDialog.style";

interface IProps {
  open: boolean;
  onClose: () => void;
}

const DeviceBlockedDialog: React.FC<IProps> = ({ open, onClose }) => {
  const classes = useStyles();

  const { setGlobalErrorReport } = useStoreActions((actions) => actions.errorMessage);
  const { globalErrorReport } = useStoreState((state) => state.errorMessage);

  const handleContactSupport = () => {
    setGlobalErrorReport({
      ...globalErrorReport,
      showGlobalReport: true,
      messageDescription: t`Device is blocked and cannot be registered`
    });
    onClose();
  };

  return (
    <BaseDialog
      className={classes.dialogRoot}
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={handleContactSupport}
      title={t`Device Cannot Be Registered`}
      cancelLabel={t`Close`}
      confirmLabel={t`Contact Support`}
    >
      <div className={classes.content}>
        <svg className={classes.icon} width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="28" cy="28" r="28" fill="#F05146" fillOpacity="0.2" />
          <path d="M37.972 18.028L18.028 37.972" stroke="#F05146" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M18.028 18.028L37.972 37.972" stroke="#F05146" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <Typography className={classes.message}>
          {t`This device is blocked and cannot be registered.`}
        </Typography>
        <Typography className={classes.message}>
          {t`Please contact Support for assistance.`}
        </Typography>
      </div>
    </BaseDialog>
  );
};

export default DeviceBlockedDialog;
